import Select, { SelectItem, SelectProps } from '@/components/Select';

interface DeviceSelect extends SelectProps {
  title: string;
  devices: MediaDeviceInfo[];
}

export default function FieldDeviceSelect(props: DeviceSelect) {
  const { devices, title, ...selectProps } = props;

  return (
    <fieldset className="mb-[15px] flex items-center gap-5">
      <label className="min-w-24 text-right text-sm text-gray-500 dark:text-gray-400" htmlFor="username">
        {title}
      </label>
      <Select {...selectProps}>
        {devices.map(device =>
          <SelectItem key={device.deviceId} value={device.deviceId}>{device.label}</SelectItem>
        )}
      </Select>
    </fieldset>
  )
}
